( function () {
    'use strict';
    // Cookie message
    e.util.cookie = {};
    e.util.cookie.message = function () {
        var jCookieMessage = jQuery( '.e-cookie-message' ).first();
        if ( jQuery.cookie('Dynamicweb.CookieOptInLevel') === undefined && jCookieMessage.length === 1 ) {
            jCookieMessage.find( '.CookieOptInLevelConfig' ).on( 'click', function ( event ) {
                event.preventDefault();
                jQuery.get( this.href );
                jCookieMessage.slideUp( 60, function () {
                    e.constant.jWindow.triggerHandler( 'resize' );
                } );
            } );
            jCookieMessage.slideDown( 120, function () {
                e.constant.jWindow.triggerHandler( 'resize' );
            } );
        }
    };
}() );
